import { SubmissionRateCardPanelRateGuide } from './RateGuide'

const SubmissionRateCardPanel = () => {
  return <SubmissionRateCardPanelRateGuide />
}

export default SubmissionRateCardPanel
